import { useEffect, useState } from "react"
import { collection, doc, getDoc, getDocs, getFirestore, limit, onSnapshot, orderBy, query, Timestamp, where } from "firebase/firestore";
import Celebrity from "../celebrity";
import User from "../user";
import TopCelebs from "./topCelebs";
import TopUsers from "./topUsers";


export default function TopPeople() {

    const db = getFirestore();
    const [topCelebDetails, setCelebDetails] = useState([]);
    const [topCelebValues, setCelebValues] = useState([]);
    const [topUserDetails, setUserDetails] = useState([]);
    const [topUserValues, setUserValues] = useState([]);


    useEffect(async () => {
        const q = query(collection(db, "requests"));
        const querySnapshot = await getDocs(q);






        var tempCelebMap = new Map();

        querySnapshot.forEach((doc) => {
            tempCelebMap.set(doc.data()["celebrity"].toString(), 0);
        });

        querySnapshot.forEach((doc) => {
            var tempValue = tempCelebMap.get(doc.data()["celebrity"].toString());
            tempCelebMap.set(doc.data()["celebrity"].toString(), tempValue + 1);
        });


        var mapAsc = new Map([...tempCelebMap].sort((a, b) => String(a[1]).localeCompare(b[1])).reverse());
        var topCelebIds = [...mapAsc.keys()];
        var topCelebVals = [...mapAsc.values()];
        setCelebDetails([...topCelebIds]);
        setCelebValues([...topCelebVals]);













        var tempUserMap = new Map();

        querySnapshot.forEach((doc) => {
            tempUserMap.set(doc.data()["user"].toString(), 0);
        });

        querySnapshot.forEach((doc) => {
            var tempValue = tempUserMap.get(doc.data()["user"].toString());
            tempUserMap.set(doc.data()["user"].toString(), tempValue + 1);
        });


        var mapAsc = new Map([...tempUserMap].sort((a, b) => String(a[1]).localeCompare(b[1])).reverse());
        var topUserIds = [...mapAsc.keys()];
        var topUserVals = [...mapAsc.values()];
        setUserDetails([...topUserIds]);
        setUserValues([...topUserVals]);

        console.log("printing");
    }, []);




    return (
        <div>

            <div className=" mb-20 h-full w-full flex flex-row">

                <TopCelebs></TopCelebs>


                <TopUsers></TopUsers>


            </div>

        </div>
    )
}